import React, { useEffect, useState } from 'react'
import Footer from '../component/Footer'
import api from '../api';

const TremsCondition = () => {
    const [terms, setTerms] = useState("");
    console.log("______terms", terms);


    const getTermsCondition = async () => {
        try {
            const storedData = localStorage.getItem("userData");
            const token = storedData ? JSON.parse(storedData).token : null;
            const res = await api.get("/user/policy_and_terms", {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                }, params: {
                    type: "terms",
                    lang: "en",
                },
            }
            );
            setTerms(res.data);
            // console.log("policy____________________", res.data);

        } catch (error) {
            console.log("error", error.message);
        }
    }
    useEffect(() => {
        getTermsCondition();
    }, []);
    return (
        <>
            <div className="container-fluid mt-5 mb-5">

                <div>
                    <h3 className='mt-5 text-center'>{terms?.data?.title}</h3>
                    <p
                        className="mt-5"
                        dangerouslySetInnerHTML={{ __html: terms?.data?.content || '' }}
                    ></p>

                </div>


            </div>

            <Footer />
        </>
    )
}

export default TremsCondition
